import { EAccountIsFired } from '../../enum'

// Create a union type of all possible values from the enum
type IAccountIsFiredLangKey = `${EAccountIsFired}`

export type IAccountIsFiredLang = {
	account_is_fired: Record<IAccountIsFiredLangKey, string>
}

const langEntries = Object.entries(EAccountIsFired).map(
	([key, value]) => [value, `account_is_fired.${value}`]
)

const langObj: Record<IAccountIsFiredLangKey, string> = Object.fromEntries(langEntries)

export const ACCOUNT_IS_FIRED_LANG_KEY: IAccountIsFiredLang = {
	account_is_fired: langObj
}
